import { Flex } from '../common';
import { Col, Row } from 'antd';
import SurveyQuestions from './SurveyQuestions';
import { SurveyParticipateContextProvider } from './contexts';

export interface SurveyParticipate {
  survey: SurveyEntity;
}

export default function SurveyParticipate({ survey }: SurveyParticipate) {

  const { questions = [] } = survey;

  return (
    <SurveyParticipateContextProvider>
      <Row gutter={[16, 16]}>
        <Col lg={6} span={0}></Col>
        <Col lg={12} span={24}>
          <Flex direction="column" className="h-full">
            <SurveyQuestions survey={survey} questions={questions} />
          </Flex>
        </Col>
        <Col lg={6} span={0}>
        </Col>
      </Row>
    </SurveyParticipateContextProvider>
  );
}
